<template>
    <CRow>
        <CCol col>
            <div id="marketPricingLog">
                <div style="width:100%; height: 80vh;">
                    <ejs-grid ref='grid' :dataSource="marketPricingLogsData" :allowFiltering='true' :allowPaging="true"
                              :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' 
                              :toolbar='toolbar' :pageSettings='pageSettings'  :actionBegin='actionBegin' :excelQueryCellInfo='excelQueryCellInfo'
                              :actionFailure="actionFailure" :filterSettings='filterOptions' width="100%" height="100%" :queryCellInfo='queryCellInfo' >
                        <e-columns>
                            <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='marketPricingPerDayId' headerText='Market Pricing Id' width=120></e-column>
                            <e-column field='year' headerText='Year' textAlign='Left' width=120 type="number"></e-column>
                            <!--<e-column field='period' headerText='Period Indicator' textAlign='Left' :visible:'false'></e-column>-->
                            <e-column field='periodName' headerText='Period Indicator' textAlign='Left' width=180 type="string"></e-column>
                            <!--<e-column field='periodSpanId' ref="dpPeriod" headerText='Period' :visible="false" textAlign='Left' width=150></e-column>-->
                            <e-column field='periodSpanName' headerText='Period' textAlign='Left' width=150 type="string"></e-column>
                            <!--<e-column field='ricId' headerText='RIC Root' textAlign='Left' :visible="false" width=130></e-column>-->
                            <e-column field='fullRicName' headerText='Identifier' textAlign='Left' width=130 type="string"></e-column>
                            <e-column field='stateName' headerText='Country' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='universalClosePriceDate' headerText='Settlement Date' textAlign='Left' type="date" :format='dateFormatOptions' width=180></e-column>
                            <e-column field='price' headerText='Settlement Price' textAlign='Left' type="number" format="n3" width=180></e-column>
                            <e-column field='tradingUnitPreview' headerText='Trading Unit' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='createdBy' headerText='Created By' textAlign='Left' width=190 type="string"></e-column>
                            <e-column field='createdDate' headerText='Import Date' textAlign='Left' :format='dateFormatOptions' type='date' width=150></e-column>
                            <e-column field='date' headerText='Date' textAlign='Left' :visible='false' width=150></e-column>
                            <e-column field='logDate' headerText='Date Stamp' textAlign='Left' width=190 type="date" :format='dateFormatOptions'></e-column>
                            <e-column field='timeStamp' headerText='Time Stamp' textAlign='Left' type='string' width=150></e-column>
                            <e-column field='userName' headerText='User' textAlign='Left' width=150 type="string"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Toolbar, Page, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import authToken from '../../common/authToken';
    import urls from '../../common/urls';
    import store from '../../store';
    import apis from '../../common/network'
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'

    import { createSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(GridPlugin);
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                marketPricingLogsData: this.$store.state.permissions["Permissions.EnergyLogs.View"] ? SyncHelper.getDataManager("MarketPricingPerDayLogs") : [],
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 100, pageCount: 4 },
                toolbar: ['ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Market Pricing Logs.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);//add ,this.$refs)is always for filtering -> offset this.$refs
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
            queryCellInfo(args) {

                if (args.column.field === 'timeStamp') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['timeStamp']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            excelQueryCellInfo(args) {

                if (args.column.field === 'timeStamp') {
                    args.value = this.convertUTCDateToLocalTime(args.data['timeStamp']);
                }
            },
            actionComplete: function (args) {
                gridOptions.actionComplete(args, this.$refs);

            },
        },
        computed: {

        },
        provide: {
            grid: [Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };
</script>
<style scoped>
    .market-price-padding {
        padding-top: 30px;
    }
</style>